(function () {
  const designers = {
    init() {
      this.$el = document.querySelector('section.designers')

      if (this.$el !== null) {
        console.log('Initializing designers...')

        // because this is the only way to reference it in removeEventList...
        this.destroyBinded = this.destroy.bind(this)

        this.setUpSwiper()
        this.setUpListeners()
      }
    },

    setUpSwiper() {
      const $slides = this.$el.querySelector('.slider')

      this.slider = tns({
        container: $slides.querySelector('.slides_wrapper'),
        loop: true,
        preventActionWhenRunning: true,
        mouseDrag: true,
        slideBy: 1,
        autoplay: true,
        items: 1,
        swipeAngle: false,
        // autoWidth: true,
        autoplayButtonOutput: false,
        prevButton: $slides.querySelector('.button.prev'),
        nextButton: $slides.querySelector('.button.next'),
        responsive: {
          768: {
            center: true,
            items: 3
          }
        }
      })
    },

    setUpListeners() {
      PubSub.subscribe('page.transitionStartDone', this.destroyBinded)
    },

    destroy() {
      console.log('Destroy: designers')

      PubSub.unsubscribe('page.transitionStartDone', this.destroyBinded)

      this.slider.destroy()
    }
  }

  Object.assign(designers, window.tangleweb)

  designers.init()
  PubSub.subscribe('page.inDOM', designers.init.bind(designers))
})()
